import {
  authMessageSchema,
  authSessionSchema,
  loginRequestSchema,
  registerRequestSchema,
  type AuthMessage,
  type AuthSession,
  type LoginRequest,
  type RegisterRequest,
} from '@/types';
import { defineEndpoint } from './base';

export const AUTH_CONTRACT = {
  login: defineEndpoint<LoginRequest, AuthSession>({
    method: 'POST',
    path: '/auth/login',
    auth: 'public',
    schemas: {
      request: loginRequestSchema,
      response: authSessionSchema,
    },
  }),
  logout: defineEndpoint<void, AuthMessage>({
    method: 'POST',
    path: '/auth/logout',
    auth: 'authenticated',
    schemas: {
      response: authMessageSchema,
    },
  }),
  register: defineEndpoint<RegisterRequest, AuthMessage>({
    method: 'POST',
    path: '/auth/register',
    auth: 'public',
    schemas: {
      request: registerRequestSchema,
      response: authMessageSchema,
    },
  }),
  me: defineEndpoint<void, AuthSession>({
    method: 'GET',
    path: '/auth/me',
    auth: 'authenticated',
    schemas: {
      response: authSessionSchema,
    },
  }),
} as const;
